/**
 * @file Shift Select Component.
 */

import PropTypes from 'prop-types';

import useShiftSelect from '../../hooks/useShiftSelect';

const propTypes = {
  items: PropTypes.array.isRequired,
  onSelectItems: PropTypes.func.isRequired,
  onDeselectItems: PropTypes.func.isRequired,
  children: PropTypes.func.isRequired,
};

const ShiftSelect = ({ items, onSelectItems, onDeselectItems, children }) => {
  const { onToggleSelectedItem } = useShiftSelect(
    items,
    onSelectItems,
    onDeselectItems,
  );

  return children({ onToggleSelectedItem });
};

ShiftSelect.propTypes = propTypes;

export default ShiftSelect;
